'use strict';

const jQuery = require('jquery');

const mediator = require('./../../../core/mediator');
const ContentRepository = require('./../repository/ContentRepository');
const Notifier = require('./../../../services/notifier');
const Translator = require('./../../../core/translator');

const doUpload = (file, src, name) => {
  let resource = {
    originalname: name,
    src: src.replace(new RegExp('^data:' + file.type + ';base64,', 'g'), ''),
  };

  let data = {prevent: false, name, file, src};

  mediator.publish('before:send:upload', data);

  return data.prevent ? data.callback(resource) : ContentRepository.upload(resource);
};

/**
 * Check image is valid
 * @param {object} file
 * @param {boolean} isImage Is true by default
 * @returns {*} Promise
 */
const imageIsValid = (file, isImage = true) => {
  let dfd = jQuery.Deferred();
  let availableImageFormats = ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'];
  if (isImage && !availableImageFormats.includes(file.type) && file.size !== 0) {
    Notifier.warning(Translator.translate('image_format_invalid'));
    dfd.reject();
  } else {
    dfd.resolve();
  }
  return dfd.promise();
};

module.exports.doUpload = doUpload;
module.exports.imageIsValid = imageIsValid;

module.exports.upload = (file, config = {}) => {
  let dfd = jQuery.Deferred();
  let data = {file, config, promise: null};
  let name = config.name || file.name;

  mediator.publish('before:upload', data);

  if (data.promise) {
    data.promise.done((src) => {
      doUpload(file, src, name).done((response) => {
        if (typeof config.afterUpload === 'function') {
          config.afterUpload(response, src, file);
        }

        dfd.resolve(response);
      });
    });
  } else if (config.src) {
    doUpload(file, config.src, name).done((response) => {
      if (typeof config.afterUpload === 'function') {
        config.afterUpload(response, config.src, file);
      }

      dfd.resolve(response);
    });
  } else {
    let reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = function() {
      doUpload(file, reader.result, name).done((response) => {
        if (typeof config.afterUpload === 'function') {
          config.afterUpload(response, reader.result, file);
        }

        dfd.resolve(response);
      });
    };
  }

  return dfd.promise();
};
